import { Form } from "informed";
import * as React from "react";
import { useParams } from "react-router-dom";
import DocumentTitle from "../../misc/components/DocumentTitle";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { DiaryConfigurationForm, DiaryConfiguratonFormModel } from "./CreateDiaryConfiguration";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export const EditDiaryConfigurationScreen = () => {
    const { id } = useParams<{ id: string }>();
    const [config, setConfig] = React.useState<DiaryConfiguratonFormModel>();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getData = async () => {
            const result = await legacyClient.getEDiaryConfigurations({
                Filters: [
                    { Member: "Id", Values: [id] }
                ]
            });

            setConfig(result.Data[0]);
        }

        getData();
    }, []);

    if (!config) return (<LoadingWithMessage message="Loading Diary Configuration..." />);

    return (
        <DocumentTitle title="Edit Diary Configuration | Vitalograph Web Portal">
            <Form noValidate initialValues={config}>
                <DiaryConfigurationForm submitApi={(formApi) => legacyClient.editEDiaryConfiguration({...formApi, Id: id})} />
            </Form>
        </DocumentTitle>
    );
}
